module.exports = __webpack_public_path__ + "img/dashboard-floor-map.a0707d69.png";